// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Evaluation result of a submission
 */
export interface SubmissionEvaluationResultOutput {
  /** Evaluation of FORMAL dimension */
  formal?: unknown;
  /** Evaluation of DESCRIPTION dimension */
  description?: unknown;
  /** Evaluation of ANALYSIS dimension */
  analysis?: unknown;
  /** Evaluation of APPLICATION dimension */
  application?: unknown;
  /** Evaluation of REFLECTION dimension */
  reflection?: unknown;
}
